import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { CryptoPaymentMethodType } from "../components/common/CryptoPaymentMethod.js";
/**
 * Custom hook to manage crypto payment method state with dual-state system:
 *
 * - `cryptoPaymentMethod`: Auto-selected based on wallet availability and balance
 * - `selectedCryptoPaymentMethod`: Explicitly selected by user
 * - `effectiveCryptoPaymentMethod`: User selection takes priority over auto-selection
 *
 * This allows automatic payment method suggestions while respecting explicit user choices.
 *
 * @example
 * ```tsx
 * const {
 *   cryptoPaymentMethod,
 *   setCryptoPaymentMethod,
 *   selectedCryptoPaymentMethod,
 *   setSelectedCryptoPaymentMethod,
 *   effectiveCryptoPaymentMethod,
 *   resetPaymentMethods
 * } = useCryptoPaymentMethodState();
 *
 * // Use effectiveCryptoPaymentMethod for display
 * // Use setSelectedCryptoPaymentMethod when user explicitly selects
 * // Call resetPaymentMethods when switching tabs or going back
 * ```
 */
export function useCryptoPaymentMethodState() {
  const $ = _c(5);
  const [cryptoPaymentMethod, setCryptoPaymentMethod] = useState(CryptoPaymentMethodType.NONE);
  const [selectedCryptoPaymentMethod, setSelectedCryptoPaymentMethod] = useState(CryptoPaymentMethodType.NONE);
  const effectiveCryptoPaymentMethod = selectedCryptoPaymentMethod !== CryptoPaymentMethodType.NONE ? selectedCryptoPaymentMethod : cryptoPaymentMethod;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setCryptoPaymentMethod(CryptoPaymentMethodType.NONE);
      setSelectedCryptoPaymentMethod(CryptoPaymentMethodType.NONE);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const resetPaymentMethods = t0;
  let t1;
  if ($[1] !== cryptoPaymentMethod || $[2] !== effectiveCryptoPaymentMethod || $[3] !== selectedCryptoPaymentMethod) {
    t1 = {
      cryptoPaymentMethod,
      setCryptoPaymentMethod,
      selectedCryptoPaymentMethod,
      setSelectedCryptoPaymentMethod,
      effectiveCryptoPaymentMethod,
      resetPaymentMethods
    };
    $[1] = cryptoPaymentMethod;
    $[2] = effectiveCryptoPaymentMethod;
    $[3] = selectedCryptoPaymentMethod;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}